/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_ApprovedInputs */

const en_wb_management_approved = /** @type {(inputs: Wb_Management_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example approved. The next step would be to post the brief to the agreed team channel.`)
};

const lv_wb_management_approved = /** @type {(inputs: Wb_Management_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs apstiprināts. Nākamais solis būtu publicēt kopsavilkumu saskaņotajā komandas kanālā.`)
};

/**
* | output |
* | --- |
* | "Example approved. The next step would be to post the brief to the agreed team channel." |
*
* @param {Wb_Management_ApprovedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_approved = /** @type {((inputs?: Wb_Management_ApprovedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_ApprovedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_approved(inputs)
	return en_wb_management_approved(inputs)
});